import {HStackProps, ValueByDevice} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

import type {DropdownPosition} from './DropdownPosition';
import type {EntityHeaderAction} from './EntityHeaderAction';

export interface EntityHeaderActionsProps extends TestIdProps {
  actions: EntityHeaderAction[] | Nullish;
  dropdownPosition: DropdownPosition | ValueByDevice<DropdownPosition>;
  maxVisibleActions?: number | ValueByDevice<number>;
  shouldStretchActions?: boolean;
  wrap?: HStackProps['wrap'];
}
